import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

import { Icon, IconNameAndCategoryString } from '../../Icon'
import Heading from '../../app/design/Heading'
import Label from '../../app/design/Label'
import Paragraph from '../../app/design/Paragraph'

type Props = {
    icon: IconNameAndCategoryString | JSX.Element
    title: string
    subtitle: string
    secondaryView?: ReactNode
    href?: string
    titleSize?: 'large' | 'medium'
    hasHoverEffect?: boolean
}

export const IconField = ({
    icon,
    title,
    subtitle,
    secondaryView,
    href,
    titleSize = 'large',
    hasHoverEffect = false,
}: Props) => {
    const iconElement =
        typeof icon === 'string' ? (
            <Icon icon={icon} background="round" className="shrink-0" />
        ) : (
            icon
        )

    return (
        <div className="group relative flex items-center justify-center gap-x-4">
            {hasHoverEffect &&
                (href !== undefined ? (
                    <Link
                        to={href}
                        className="absolute -inset-4 rounded-lg group-hover:bg-black/4"
                    />
                ) : (
                    <div className="absolute -inset-4 rounded-lg group-hover:bg-black/4" />
                ))}

            {href !== undefined ? (
                <Link to={href} className="group relative">
                    {iconElement}
                    {!hasHoverEffect && (
                        <div className="absolute inset-0 rounded-full hover:bg-black/20" />
                    )}
                </Link>
            ) : (
                iconElement
            )}

            <div className="flex grow flex-col items-stretch justify-start gap-y-1">
                {titleSize === 'large' && (
                    <Heading size="xs" className="text-gray-700">
                        {href !== undefined ? (
                            <Link to={href} className="hover:text-gray-700 hover:underline">
                                {title}
                            </Link>
                        ) : (
                            title
                        )}
                    </Heading>
                )}
                {titleSize === 'medium' && (
                    <Label className="text-gray-700">
                        {href !== undefined ? (
                            <a href={href} className="hover:text-gray-700 hover:underline">
                                {title}
                            </a>
                        ) : (
                            title
                        )}
                    </Label>
                )}
                <Paragraph size="md" className="font-normal text-gray-600">
                    {subtitle}
                </Paragraph>
            </div>

            {secondaryView}
        </div>
    )
}
